/**
 * 是否数组
 */
export function isArray(value) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  } else {
    return Object.prototype.toString.call(value) === "[object Array]";
  }
}
/**
 * 是否对象
 */
export function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js